import { useEffect, Fragment } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { obtenerProveedor, editarProveedor, limpiarProveedor } from '../../actions/proveedores';

const EditarProveedor = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Proveedores',
            path: '/proveedores'
        },
        {
            activo: true,
            nombre: 'Editar proveedor',
            path: '/proveedores/editar/'
        }
    ];

    const dispatch = useDispatch();
    
    const navigate = useNavigate();

    const { proveedor } = useSelector(state => state.auth);

    const { id } = useParams();

    const { detalles } = useSelector(state => state.proveedores);

    const [proveedorData, setProveedorData] = useState({
        id: null,
        nombre: '',
        correo: '',
        direccion: '',
        telefono: '',
        rfc: '',
        contacto: ''
    });


    /* Editar usuario */
    const handleInputChange = ({ target }) => {
        setProveedorData({
            ...proveedorData,
            [target.name]: target.value
        });
    }

    const handleEditarProveedor = async () => {
        if(proveedorData.nombre){
            await dispatch(editarProveedor(proveedorData));
            await navigate("/proveedores");
        }else{
            await dispatch(setAlert('El campo nombre es obligatorio', 'danger'));
        }
    }

   

    useEffect(() => {
        dispatch(limpiarProveedor());

        return () => {
            dispatch(limpiarProveedor());
        }
    }, []);

    useEffect(() => {
        dispatch(obtenerProveedor(id));

        if(id){
            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        setProveedorData({
            ...proveedorData,
            id: detalles?._id,
            nombre: detalles?.nombre,
            correo: detalles?.correo,
            direccion: detalles?.direccion,
            telefono: detalles?.telefono,
            rfc: detalles?.rfc,
            contacto: detalles?.contacto
        });
    }, [detalles, proveedor]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Editar Proveedor</h3>
                    
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={proveedorData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Correo" id="correo" name="correo" value={proveedorData.correo} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="correo">Correo</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Dirección" id="direccion" name="direccion" value={proveedorData.direccion} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="direccion">Dirección</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Teléfono" id="telefono" name="telefono" value={proveedorData.telefono} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="telefono">Teléfono</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="RFC" id="rfc" name="rfc" value={proveedorData.rfc} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="rfc">RFC</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Contacto" id="contacto" name="contacto" value={proveedorData.contacto} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="direccion">Contacto</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleEditarProveedor}>Guardar</button>
                            <Link to='/proveedores'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default EditarProveedor;